const GAME_STATES = {
    NEW_GAME: 'NEW_GAME',
    PLAYING: 'PLAYING',
    PAUSED: 'PAUSED',
    GAME_OVER: 'GAME_OVER',
};

export default GAME_STATES;
